import './googleAnalyticsLoader.js';

const GA_SEND = 'ActionButtonTracker.send';

const GA_WIDGET_NAME = 'dimension1';
const GA_WIDGET_ID = 'dimension2';
const GA_ACTION_ID = 'dimension3';
const GA_ARTICLE_ID = 'dimension4';
const GA_PUBLISHER_KEY = 'dimension5';
const GA_PARTNER_NAME = 'dimension6';
const GA_ACTION_ORDER = 'dimension7';
const GA_ARTICLE_URL = 'dimension8';
const GA_SHARED_WITH = 'dimension9';
const GA_PAYMENT_METHOD = 'dimension10';
const GA_POLL_ANSWER = 'dimension11';
const GA_PUBLISHER_ID = 'dimension12';
const GA_CLIENT_ID = 'dimension13';
const GA_PUBLISHED_DATE = 'dimension14';
const GA_ISSUE = 'dimension15';
const GA_SUBISSUE = 'dimension16';
const GA_END_USER_ID = 'dimension17';
const GA_NOTIFY_RESULT = 'dimension18';
const GA_CUSTOM_CLIENT_ID = 'dimension19';
const GA_EMBED_TYPE = 'dimension20';

const GA_ACTION_INITIATED = 'metric1';
const GA_ACTION_COMPLETED = 'metric2';
const GA_ACTION_SEEN = 'metric3';
const GA_ACTION_SHARED = 'metric4';
const GA_DONATION_AMOUNT = 'metric5';
const GA_DONATION_AMOUNT_SELECTED = 'metric6';
const GA_DONATION_PAYMENT_SUBMITTED = 'metric7';
const GA_ACTION_CANCELED_TIME = 'metric8';
const GA_ACTION_CANCELED = 'metric9';
const GA_ACTION_COMPLETE_TIME = 'metric10';
// const GA_PUBLISHED_DATE_DEPRICATED = 'metric11'
const GA_WIDGET_VISIBLE = 'metric12';

export const EVENT_ACTION_SEEN = 'Action Seen';
export const EVENT_ACTION_INITIATED = 'Action Started';
export const EVENT_ACTION_COMPLETED = 'Action Completed';
export const EVENT_ACTION_CANCELED = 'Action Canceled';
export const EVENT_ACTION_SHARED = 'Action Shared';
export const EVENT_DONATION_AMOUNT_SELECTED = 'Donation Amount Selected';
export const EVENT_DONATION_PAYMENT_SUBMITED = 'Donation Payment Submitted';
export const EVENT_WIDGET_VISIBLE = 'Widget Visible';
export const EVENT_NEWSLETTER_SUBSCRIPTION = 'Newsletter Subscription';
export const EVENT_VIDEO_SAVED = 'Video Saved';
export const GLOBAL_FALLBACK_ACTION = 'FallbackAction';

let clientId = null;
let eventsClientId = null;
let googleId = null;

export function getGoogleAnalyticsClientIds() {
    return { clientId: eventsClientId, googleId };
}

export function loadGoogleAnalytics(options) {
    if (typeof abGoogleAnalytics === 'undefined') return;
    /* global abGoogleAnalytics */

    abGoogleAnalytics(
        'create',
        options.googleAnalyticsUserId,
        'auto',
        'ActionButtonTracker'
    );
    abGoogleAnalytics('ActionButtonTracker.set', 'page', options.articleUrl);
    abGoogleAnalytics('ActionButtonTracker.set', 'userId', options.clientIdCustom);

    clientId = options.clientIdCustom;
    abGoogleAnalytics(() => {
        clientId = abGoogleAnalytics.getByName('ActionButtonTracker').get('clientId');
    });

    abGoogleAnalytics(GA_SEND, {
        hitType: 'pageview',
        page: options.articleUrl
    });

    abGoogleAnalytics(
        'create',
        options.googleAnalyticsEventUserId,
        'auto',
        'ActionButtonEventsTracker'
    );
    abGoogleAnalytics('ActionButtonEventsTracker.set', 'page', options.articleUrl);
    abGoogleAnalytics('ActionButtonEventsTracker.set', 'userId', options.clientIdCustom);
    abGoogleAnalytics(() => {
        const tracker = abGoogleAnalytics.getByName('ActionButtonEventsTracker');
        eventsClientId = tracker.get('clientId');
        googleId = tracker.get('_gid');
    });

    abGoogleAnalytics('ActionButtonEventsTracker.send', {
        hitType: 'pageview',
        page: options.articleUrl
    });
}

function getGoogleAnalyticsEvent(eventAction, data) {
    const action = data.action;

    const gaEvent = {
        hitType: 'event',
        eventAction,
        eventCategory: action ? action.type : 'widget',
        eventLabel: action ? action.name : data.widgetName
    };

    gaEvent[GA_WIDGET_NAME] = data.widgetName;
    gaEvent[GA_WIDGET_ID] = data.widgetId.toString();
    gaEvent[GA_PUBLISHER_ID] = data.publisherId.toString();
    gaEvent[GA_PUBLISHER_KEY] = data.publisherKey;
    gaEvent[GA_ARTICLE_ID] = data.articleId.toString();
    gaEvent[GA_ARTICLE_URL] = data.articleUrl;
    gaEvent[GA_CLIENT_ID] = clientId;
    gaEvent[GA_END_USER_ID] = data.endUserId;
    gaEvent[GA_NOTIFY_RESULT] = data.notifyResult;
    gaEvent[GA_CUSTOM_CLIENT_ID] = data.clientIdCustom;
    gaEvent[GA_EMBED_TYPE] = data.embedType;

    if (data.publishedDate) gaEvent[GA_PUBLISHED_DATE] = data.publishedDate;

    if (eventAction === EVENT_WIDGET_VISIBLE) gaEvent[GA_WIDGET_VISIBLE] = 1;

    if (action && action.issue) gaEvent[GA_ISSUE] = action.issue.name;
    if (action && action.subIssue) gaEvent[GA_SUBISSUE] = action.subIssue.name;

    if (data.widgetActionCount) gaEvent.eventValue = data.widgetActionCount;

    if (!action) return gaEvent;

    // action specific fields
    gaEvent[GA_ACTION_ID] = action.identifier;
    gaEvent[GA_PARTNER_NAME] = action.partner ? action.partner.name : null;
    gaEvent[GA_ACTION_ORDER] = action.order.toString();

    if (data.sharedWith) gaEvent[GA_SHARED_WITH] = data.sharedWith;
    if (action.type === 'donation' && action.partner) {
        gaEvent[GA_PAYMENT_METHOD] = action.partner.paymentMethod;
        if (data.amount) gaEvent[GA_DONATION_AMOUNT] = data.amount;
    }

    if (data.answerText) gaEvent[GA_POLL_ANSWER] = data.answerText;
    if (data.actionCancelTime) {
        gaEvent[GA_ACTION_CANCELED_TIME] = Math.round(data.actionCancelTime);
    }
    if (data.actionCompleteTime) {
        gaEvent[GA_ACTION_COMPLETE_TIME] = Math.round(data.actionCompleteTime);
    }

    if (eventAction === EVENT_ACTION_INITIATED) gaEvent[GA_ACTION_INITIATED] = 1;
    if (eventAction === EVENT_ACTION_COMPLETED) gaEvent[GA_ACTION_COMPLETED] = 1;
    if (eventAction === EVENT_ACTION_CANCELED) gaEvent[GA_ACTION_CANCELED] = 1;
    if (eventAction === EVENT_ACTION_SEEN) gaEvent[GA_ACTION_SEEN] = 1;
    if (eventAction === EVENT_ACTION_SHARED) gaEvent[GA_ACTION_SHARED] = 1;
    if (eventAction === EVENT_DONATION_AMOUNT_SELECTED)
        gaEvent[GA_DONATION_AMOUNT_SELECTED] = 1;
    if (eventAction === EVENT_DONATION_PAYMENT_SUBMITED)
        gaEvent[GA_DONATION_PAYMENT_SUBMITTED] = 1;

    return gaEvent;
}

export default function sendGoogleAnalyticsEvent(eventName, data) {
    if (typeof abGoogleAnalytics === 'undefined') return;
    const gaEvent = getGoogleAnalyticsEvent(eventName, data);
    abGoogleAnalytics(GA_SEND, gaEvent);
}
